/*!

=========================================================
* Argon Dashboard React - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useState, useEffect} from "react";
import { manualClock,last20Clocks } from 'network/ApiAxiosSchedule';
// node.js library that concatenates classes (strings)
// reactstrap components
import {
  Button,Table,
  Card,
  CardHeader,
  CardBody,
  Container,
  Row,
  Col,
  
} from "reactstrap";

const Index = (props) => {
  const [lastClocks, setLastClocks] = useState(null);

  useEffect(() => {
    fetchLast20Clocks();
  }, []);

  const id = JSON.parse(localStorage.getItem('user'))._id
  const role = JSON.parse(localStorage.getItem('user')).role

  const fetchLast20Clocks = async()=>{
    const resp = await last20Clocks(id)
    if(resp.data.success){
      setLastClocks(resp.data.clocks)
    }
  }
    return (
      <>
        {/* Page content */}
        <Container fluid>
            
          <Row>
            <Col className="mb-5 mb-xl-0" xl="12">
              <Card className="bg-gradient-default shadow">
                <CardHeader className="bg-transparent">
                  <Row className="align-items-center">
                    <div className="col">
                      <h2 className="text-white mb-0">Clock IN/OUT</h2>
                    </div>
                  </Row>
                </CardHeader>
                <CardBody>
                {lastClocks != null &&<Table dark hover responsive striped>
                    <thead>
                      <tr> 
                        <td colSpan="4">
                        </td>
                      </tr>
                      <tr>
                        <th>
                          ClockIn
                        </th>
                        <th>
                          ClockOut
                        </th>
                        <th>
                          ClockIn2
                        </th>
                        <th>
                          ClockOut2
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {lastClocks.map((clockItem)=>{
                        return <tr key={clockItem._id}>
                          <th scope="row">
                            {clockItem.ClockIn && clockItem.ClockIn.slice(0,16)}
                          </th>
                          <td>
                            {clockItem.ClockOut && clockItem.ClockOut.slice(0,16)}
                          </td>
                          <td>
                            {clockItem.ClockIn2 && clockItem.ClockIn2.slice(0,16)}
                          </td>
                          <td>
                            {clockItem.ClockOut2 && clockItem.ClockOut2.slice(0,16)}
                          </td>
                        </tr>
                      })}
                    </tbody>
                  </Table>}
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col className="mb-5 mb-xl-0" xl="8">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <div className="col">
                      <h3 className="mb-0">Something</h3>
                    </div>
                    <div className="col text-right">
                      <Button
                        color="primary"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        See all
                      </Button>
                    </div>
                  </Row>
                </CardHeader>
                
              </Card>
            </Col>
            <Col xl="4">
              <Card className="shadow">
                <CardHeader className="border-0">
                  <Row className="align-items-center">
                    <div className="col">
                      <h3 className="mb-0">Something</h3>
                    </div>
                    <div className="col text-right">
                      <Button
                        color="primary"
                        href="#pablo"
                        onClick={(e) => e.preventDefault()}
                        size="sm"
                      >
                        See all
                      </Button>
                    </div>
                  </Row>
                </CardHeader>
                
              </Card>
            </Col>
          </Row>
        </Container>
      </>
    );
  
}

export default Index;
